import TradeAgreementsGenerate from './TradeAgreementsGenerate';
export default TradeAgreementsGenerate;
